import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaintenanceRoutingModule } from '@flyfreely-portal-ui/maintenance';
import { OrganisationAdminRoutingModule } from '@flyfreely-portal-ui/organisation-admin';
import { AccountPermissionsGuard } from '@flyfreely-portal-ui/ui';
import { UserProfileRoutingModule } from '@flyfreely-portal-ui/user-profile';
import { DashboardComponent } from '../dashboard.component';
import { WidgetSelectionComponent } from '../widget-selection/widget-selection.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: DashboardComponent,
                canActivate: [AccountPermissionsGuard],
                runGuardsAndResolvers: 'always',
                children: [
                    {
                        path: 'orgadmin',
                        loadChildren: () => OrganisationAdminRoutingModule
                    },
                    {
                        path: 'userprofile',
                        loadChildren: () => UserProfileRoutingModule
                    },
                    {
                        path: 'maintenance',
                        loadChildren: () => MaintenanceRoutingModule
                    }
                ]
            },
            {
                path: '',
                component: WidgetSelectionComponent,
                outlet: 'sidebar'
            }
        ])
    ],
    exports: [RouterModule]
})
export class ManageDashboardRoutingModule {}
